export function OpenIn3dButton(): JSX.Element {
  // eslint-disable-next-line react/button-has-type, prettier/prettier
  return <div />;
}
